import styled from 'styled-components'

export const Container = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    margin: auto;
    padding: 15px;
    width: 50%;
    height: fit-content;
    border: 5px solid ${({theme}) => theme.bg.mainGreen};
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    font-size: 16px;
    overflow: hidden;

    pre {
        white-space: pre-wrap;       /* css-3 */
        white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
        white-space: -o-pre-wrap;    /* Opera 7 */
        word-wrap: break-word;       /* Internet Explorer 5.5+ */
        overflow: hidden;
    }

    > div {
        word-wrap: anywhere;
        overflow-wrap: anywhere;
    }

    > button {

        padding: 5px;
        transition: all 0.3s ease;

        :hover {
            cursor: pointer;
        }
    }
`
